export default __webpack_public_path__ + "static/media/recipes.8a1dbf07.png";